import React, { memo } from "react";
import { TField } from "./Styled";

const InputText = (props) => <TField {...props} />;

export default memo(InputText);
